import { useLocation } from 'react-router-dom';

import { ProductDetailsPromotionServices, ProductDetailsPromotionServicesSkeleton } from '@components/ProductDetailsPromotionServices';
import { Promotion } from '@components/PromotionCard';

import { useProductDetailsPromotionServicesQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsPromotionServicesContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const location = useLocation();

  const { data, loading } = useProductDetailsPromotionServicesQuery({
    variables: {
      productId,
    },
    context: {
      batch: true,
    },
    skip: !productId,
  });

  if (loading) {
    return (
      <ProductDetailsPromotionServicesSkeleton />
    );
  }

  if (data?.productDetails) {
    const promotions = data.productDetails.promotions?.filter(
      (promotion) => promotion.canBePromoted && promotion.tariffs?.length,
    );

    return (
      <ProductDetailsPromotionServices
        className={className}
        productId={productId}
        promotionPackages={data.productDetails.promoPackages}
        promotions={promotions as Promotion[]}
        next={location.pathname}
        referrer="product_details"
      />
    );
  }

  return null;
};
